import { NETWORK_CARD_TYPE } from '../../../pages/MyNetwork/sharedConstants';

export const LOADING_ANIMATION_URL =
    '/v1565991146/Network/inverted_right_rail_loading_state.png';

export const transform = { animationWidth: 'c_scale,f_auto,q_auto,w_340' };

export const EMPTY_STATES = {
    pendingRequests: {
        detail: 'No pending invitations.',
        networkCardType: NETWORK_CARD_TYPE.PENDING_REQUESTS,
    },
    pendingGroupRequests: {
        detail: 'No pending invitations.',
        networkCardType: NETWORK_CARD_TYPE.PENDING_GROUP_REQUESTS,
    },
    recommendedUsers: {
        detail: 'No recommendations yet.',
        networkCardType: NETWORK_CARD_TYPE.RECOMMENDED_USERS,
    },
    connectedUsers: {
        detail: 'No connections yet.',
        networkCardType: NETWORK_CARD_TYPE.CONNECTED_USERS,
    },
    joinedGroups: {
        detail: 'Not a group member yet.',
        networkCardType: NETWORK_CARD_TYPE.JOINED_GROUPS,
    },
    invitedUsers: {
        detail: `You haven't sent any invitations yet.`,
        networkCardType: NETWORK_CARD_TYPE.INVITED_USERS,
    },
    followedUsers: {
        detail: `You aren't following anyone yet.`,
        networkCardType: NETWORK_CARD_TYPE.FOLLOWED_USERS,
    },
    recommendedGroups: {
        detail: 'No recommendations yet.',
        networkCardType: NETWORK_CARD_TYPE.RECOMMENDED_GROUPS,
    },
};
